import styled from "styled-components"

const AppStyleCtaBox = styled.div`
  display: flex;
  padding: var(--spacing_m, 12px) var(--spacing_xl, 24px) var(--spacing_l, 16px) var(--spacing_xl, 24px);
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  margin-top: auto;
`

export default AppStyleCtaBox
